import * as t from 'io-ts';

import {makeDefaultValueType} from '../../types/defaultValueType';
import {mergeNullableValue} from './nullableValue';

/*
 * Runtime types.
 */

export const RNotificationPermissionBannerPreferences = makeDefaultValueType(
  t.type({
    dismissedAt: t.union([t.number, t.null]),
    dismissedCount: makeDefaultValueType(t.number, 0),
  }),
  {dismissedAt: null, dismissedCount: 0},
);

/*
 * Types.
 */

export type NotificationPermissionBannerPreferences = t.TypeOf<
  typeof RNotificationPermissionBannerPreferences
>;

/*
 * Constants.
 */

export const defaultNotificationBannerPreferences: NotificationPermissionBannerPreferences = {
  dismissedAt: null,
  dismissedCount: 0,
};

/*
 * Conflict resolution.
 */

const mergeDismissedAt = mergeNullableValue(Math.max);

export function mergeNotificationPermissionBannerPreferences(
  left: NotificationPermissionBannerPreferences,
  right: NotificationPermissionBannerPreferences,
): NotificationPermissionBannerPreferences {
  return {
    dismissedAt: mergeDismissedAt(left.dismissedAt, right.dismissedAt),
    dismissedCount: Math.max(left.dismissedCount, right.dismissedCount),
  };
}
